import React from "react";
import ImageRatioPadder from "./pages/ImageRatioPadder";

const App: React.FC = () => {
    return (
        <div className="App">
            <ImageRatioPadder />
        </div>
    );
};

export default App;
